export const IGNORED_EXCEPTION_MESSAGES = [
  "member called after shutdown",
  "Uncaught ReferenceError: member called after shutdown",
  "Incompatible load types.",
  "Cannot pick from outside the canvas area.",
  "ResizeObserver loop",
  "ResizeObserver loop completed with undelivered notifications",
];
